export enum Orientation {
	North = 1,
	South = 2,
	West = 3,
	East = 4,
	Northeast = 14,
	Northwest = 13,
	Southeast = 24,
	Southwest = 23
}
